module.exports = "<app-sidebar>\n    <router-outlet>\n    </router-outlet>\n</app-sidebar>"